<template>
  <ul class="c-mainMenu">
    <li class="c-mainMenu__item">
      <router-link
        :to="{
          name: 'allocation-index',
          params: { mc_code: mcCode },
        }"
        class="c-mainMenu__itemInnner"
      >
        <div class="c-mainMenu__item__iconAndTitle">
          <img
            class="c-mainMenu__item__icon"
            src="/mc/assets/img/common/icon-report.png"
            alt=""
          />
          <div class="c-mainMenu__item__title">
            <a href="/1825/allocation">駐車場等お申し込み</a>
          </div>
        </div>
        <div>
          <img
            src="/mc/assets/img/common/arrow-textAside.png"
            alt="asideArrow"
          />
        </div>
      </router-link>
    </li>
    <li class="c-mainMenu__item">
      <router-link
        :to="{
          name: 'mc-event-index',
          params: { mc_code: mcCode },
        }"
        class="c-mainMenu__itemInnner"
      >
        <div class="c-mainMenu__item__iconAndTitle">
          <img
            class="c-mainMenu__item__icon"
            src="/mc/assets/img/common/icon-event.png"
            alt="event"
          />
          <div class="c-mainMenu__item__title">イベント</div>
        </div>
        <div>
          <img
            src="/mc/assets/img/common/arrow-textAside.png"
            alt="asideArrow"
          />
        </div>
      </router-link>
    </li>
    <li class="c-mainMenu__item">
      <router-link
        :to="{
          name: 'archive-list',
          params: { mc_code: mcCode, category: 1 },
        }"
        class="c-mainMenu__itemInnner"
      >
        <div class="c-mainMenu__item__iconAndTitle">
          <img
            class="c-mainMenu__item__icon"
            src="/mc/assets/img/common/icon-schedule.png"
            alt="ご入居までのスケジュール"
          />
          <div class="c-mainMenu__item__title">ご入居までのスケジュール</div>
        </div>
        <div>
          <img
            src="/mc/assets/img/common/arrow-textAside.png"
            alt="asideArrow"
          />
        </div>
      </router-link>
    </li>
    <li class="c-mainMenu__item">
      <router-link
        :to="{
          name: 'archive-list',
          params: { mc_code: mcCode, category: 2 },
        }"
        class="c-mainMenu__itemInnner"
      >
        <div class="c-mainMenu__item__iconAndTitle">
          <img
            class="c-mainMenu__item__icon"
            src="/mc/assets/img/common/icon-material.png"
            alt="ご入居に関する書類"
          />
          <div class="c-mainMenu__item__title">ご入居に関する書類</div>
        </div>
        <div>
          <img
            src="/mc/assets/img/common/arrow-textAside.png"
            alt="asideArrow"
          />
        </div>
      </router-link>
    </li>
    <li class="c-mainMenu__item">
      <router-link
        :to="{
          name: 'qa',
          params: { mc_code: mcCode },
        }"
        class="c-mainMenu__itemInnner"
      >
        <div class="c-mainMenu__item__iconAndTitle">
          <img
            class="c-mainMenu__item__icon"
            src="/mc/assets/img/common/icon-QA.png"
            alt="Q&amp;A"
          />
          <div class="c-mainMenu__item__title">Q&amp;A</div>
        </div>
        <div>
          <img
            src="/mc/assets/img/common/arrow-textAside.png"
            alt="asideArrow"
          />
        </div>
      </router-link>
    </li>
  </ul>
</template>

<script>
export default {};
</script>

<style></style>
